import { api } from "#app/http/api";
import { FilterQuery } from "shared";

export const searchParts = async ({
  filtersParams,
  limit = 9,
}: {
  filtersParams: FilterQuery;
  limit?: number;
}) => {
  const response = await api.parts.search.query({
    query: { ...filtersParams, limit },
    timeout: 30000,
  });

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
